import Marionette from "backbone.marionette";

import SetPasswordView from "components/password";
import wsStorage, { WS_STORAGE_KEY } from "lib/wsStorage";

export default Marionette.View.extend({
    el: "#login-modal",
    template: false,

    onRender() {
        this.$el.addClass("auth-component");
        if (!this.options.inline) {
            this.$el.modal({
                closeClass: "icon-close",
                closeText: "&times;",
                fadeDuration: 350,
                fadeDelay: 0,
            });

            this.$el.on("modal:close", () => {
                if (this.options.reset) {
                    wsStorage.setItem(WS_STORAGE_KEY.STOP_RESET_PASSWORD, 1, 86400);
                }
            });
        }

        new SetPasswordView({
            el: this.$(".password-container"),
            reset: this.options.reset,
            isPortal: true,
        }).render();
    },
});
